document.addEventListener("DOMContentLoaded", function () {
  const franchiseForm = document.getElementById("franchiseForm");
  if (!franchiseForm) return;

  const franchiseResponse = document.getElementById("franchiseResponse");
  const submitButton = franchiseForm.querySelector('button[type="submit"]');
  const formContent = franchiseForm.querySelector(".franchise-form-content");

  // Form validation
  const validateForm = () => {
    let isValid = true;
    const fields = franchiseForm.querySelectorAll(
      "input[required], textarea[required]"
    );

    // Reset validation state
    fields.forEach((field) => {
      field.classList.remove("is-invalid");
      const feedbackElement = field.nextElementSibling;
      if (
        feedbackElement &&
        feedbackElement.classList.contains("invalid-feedback")
      ) {
        feedbackElement.textContent = "";
        feedbackElement.style.display = "none";
      }
    });

    // Check required fields
    fields.forEach((field) => {
      if (!field.value.trim()) {
        showError(field, franchiseVars.messages.required);
        isValid = false;
      } else if (field.type === "email" && !validateEmail(field.value)) {
        showError(field, franchiseVars.messages.emailInvalid);
        isValid = false;
      } else if (field.id === "phone" && !validatePhone(field.value)) {
        showError(field, franchiseVars.messages.phoneInvalid);
        isValid = false;
      }
    });

    return isValid;
  };

  const showError = (field, message) => {
    field.classList.add("is-invalid");
    const feedbackElement = field.nextElementSibling;
    if (
      feedbackElement &&
      feedbackElement.classList.contains("invalid-feedback")
    ) {
      feedbackElement.textContent = message;
      feedbackElement.style.display = "block";
    }
  };

  const validateEmail = (email) => {
    const re =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (phone) => {
    // Simple phone validation - can be adjusted based on requirements
    return phone.replace(/\D/g, "").length >= 10;
  };

  const handleSubmission = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // Update button state
    const originalButtonText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = franchiseVars.messages.sending;

    // Get form data
    const formData = new FormData(franchiseForm);
    formData.append("action", "handle_franchise_form");
    formData.append("nonce", franchiseVars.nonce);

    try {
      const response = await fetch(franchiseVars.ajaxUrl, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        // For success, hide form elements and show success message
        if (formContent) {
          formContent.style.display = "none";
        } else {
          // If .franchise-form-content doesn't exist, hide all form elements except response
          const elementsToHide = franchiseForm.querySelectorAll(
            '.franchise-form-field, .franchise-form-row, .franchise-form-actions, input[type="hidden"]'
          );
          elementsToHide.forEach((el) => (el.style.display = "none"));
        }

        franchiseResponse.innerHTML = result.success
          ? franchiseVars.messages.success
          : result.data || franchiseVars.messages.error;

        franchiseResponse.className = "franchise-response success";
        franchiseForm.reset();
      } else {
        // For errors, show error message below the form
        franchiseResponse.innerHTML =
          result.data || franchiseVars.messages.error;
        franchiseResponse.className = "franchise-response error";
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      franchiseResponse.innerHTML = franchiseVars.messages.error;
      franchiseResponse.className = "franchise-response error";
    } finally {
      // Reset button state
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;

      // Scroll to response message
      franchiseResponse.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  // Attach event listeners
  franchiseForm.addEventListener("submit", handleSubmission);
});
